export const HomeData = [
 
];

export const CompanyManagerData = [
  {
    title: "Add new company",
    path: "/companymanage/addnewcompany",    
  },
  {
    title: "List Company",
    path: "/companymanage/listcompany"    
  },
  {
    title: "Company Client Admin",
    path: "/companymanage/companyadmins"    
  },
  {
    title: "Company Machine",
    path: "/companymanage/companymachines"    
  }
];
export const EmployeeManageData = [  
  {
    title: "Add And Edit Employee",
    path: "/employeemanage/addandeditemployee"
  },
  {
    title: "Employee Credits",
    path: "/employeemanage/employeecredit"
  },
  
];
export const GeneralManagerData = [
  
  {
    title: "Country manage",
    path: "/generalmanager/countrymanage",    
  },
  {
    title: "State manage",
    path: "/generalmanager/statemanage",    
  },
  {
    title: "City manage",
    path: "/generalmanager/citymanage",    
  },
  {
    title:"Area manage",
    path:"/generalmanager/areamanage",
  },
  {
    title: "Unit manage",
    path: "/generalmanager/unitmanage",    
  },
  {
    title: "GST Master",
    path: "/generalmanager/gst",    
  },
 
];

export const MachineManageData = [
 
  {
    title: "Add new machine",
    path: "/manage_machine/addnewmachine",
  },
  {
    title: "List Machine",
    path: "/manage_machine/listmachine",
  },
  {
    title: "Machine Configuration",
    path: "/manage_machine/machineconfiguration",
  }
];

export const MachineMappingData = [
 
  {
    title: "Device Mapping",
    path: "/MachineMapping/MachineMapping",
  },
  {
    title: "List Machine",
    path: "/MachineMapping/MappingsList",
  },
  {
    title: "Machine Configuration",
    path: "/manage_machine/machineconfiguration",
  }
];

export const RefillersManager = [
   
  {
    title: "Manage Refill Request",
    path: "/managerefillrequest",
  },
  {
    title: "Refiller Refilling Request",
    path: "/refillerrefillingrequest",
  },
  {
    title: "All Approve Request",
    path: "/allapprovedrequest",
  },
 
];

// export const RefundandSupportData = [
   
//   {
//     title: "1",
//     path: "/refundandsupport/1",
//   },
//   {
//     title: "2",
//     path: "/refundandsupport/2"
//   }
// ];

export const TransactionManageData = [

  {
    title: "Transaction Report",
    path: "/transactionreports/transaction_report",
  },
  // {
  //   title: "Credit Report",
  //   path: "/transactionreports/credit_report"
  // },
  // {
  //   title: "Credit Transaction Report",
  //   path: "/transactionreports/credit_transaction_report"
  // }
];
export const UserManagerData = [
  
  {
    title: "Add new user",
    path: "/usermanage/addnewuser",  
    cName: "abc",
  
  },
  {
      title: "List User",
      path: "/usermanage/listuser",  
      cName:"" 
 
  },
  {
    title: "User permission",
    path: "/usermanage/userpermission",    
    cName:""
  },




];
export const WareHouseData = [
   
  {
    title: "Add Ware house",
    path: "/warehouse/addwarehouse",    
  },
  {
    title: "Ware house List",
    path: "/warehouse/warehouselist",    
  },
  {
    title: "Ware house Stock",
    path: "/warehouse/warehousestock",    
  },
  
  
  
];

export const SupplierData=[
  {
    title: "Add Supplier ",
    path: "/suppliemanage/addsupplier",    
  },
  {
    title: " List Supplier",
    path: "/suppliemanage/listsupplier",    
  }
]
export const StockData=[
  {
    title: "Purchase Stock",
    path: "/stockmanage/purchasestock",    
  },
  {
    title: " List Stock",
    path: "/stockmanage/purchasestocklist",    
  },
  {
    title: "Transfer Stock",
    path: "/stockmanage/transferstock",    
  },
  {
    title: "Accept Stock Request",
    path: "/stockmanage/acceptstock",    
  },
  
  
]

export const ProductsData = [
  {
    title:"Product List",
    path:"/products/productlist"

  },
  {
    title:"Bulk Product Upload",
    path:"/products/bulkproductupload"
  },
  {
    title:"Single Product Add",
    path:"/products/singleproductadd"
  },
  {
    title:"Update Bulk Product",
    path:"/products/updatebulkproduct"
  }
];
export const salesData = [
  {
    title:"Sales Report",
    path:"/sales/salesReport"
  },
  {
    title:"Sales Summary Report",
    path:"/sales/SalesSummaryReport"
  }
];